import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LeadCapture from "./components/LeadCapture";
import Introduction from "./components/Introduction";
import Assessment from "./components/Assessment";
import AssessmentResults from "./components/AssessmentResults";
import AdminDashboard from "./components/AdminDashboard";

// Assessment stages
const STAGES = {
  INTRO: 'intro',
  ASSESSMENT: 'assessment',
  LEAD_CAPTURE: 'lead_capture',
  RESULTS: 'results'
};

function AssessmentFlow() {
  const [stage, setStage] = useState(STAGES.INTRO);
  const [lead, setLead] = useState(null);
  const [assessmentResults, setAssessmentResults] = useState(null);
  const [pendingResults, setPendingResults] = useState(null);

  const handleStartAssessment = () => {
    window.scrollTo(0, 0);
    setStage(STAGES.ASSESSMENT);
  };

  const handleAssessmentComplete = (results) => {
    window.scrollTo(0, 0);
    setPendingResults(results);
    setStage(STAGES.LEAD_CAPTURE);
  };

  const handleLeadComplete = (leadData) => {
    window.scrollTo(0, 0);
    setLead(leadData);
    setAssessmentResults(pendingResults);
    setStage(STAGES.RESULTS);
  };

  const handleRestart = () => {
    window.scrollTo(0, 0);
    setStage(STAGES.INTRO);
    setLead(null);
    setAssessmentResults(null);
    setPendingResults(null);
  };

  return (
    <>
      {stage === STAGES.INTRO && (
        <Introduction onStart={handleStartAssessment} />
      )}

      {stage === STAGES.ASSESSMENT && (
        <Assessment onComplete={handleAssessmentComplete} />
      )}

      {stage === STAGES.LEAD_CAPTURE && (
        <LeadCapture onComplete={handleLeadComplete} pendingResults={pendingResults} />
      )}
      
      {stage === STAGES.RESULTS && lead && assessmentResults && (
        <AssessmentResults 
          lead={lead} 
          results={assessmentResults} 
          onRestart={handleRestart}
        />
      )}
    </>
  );
}

function AdminPage() {
  const navigate = useNavigate();
  return <AdminDashboard onBack={() => navigate('/')} />;
}

function App() {
  return (
    <div className="App" data-testid="app-container">
      <Toaster 
        position="top-center"
        toastOptions={{
          style: {
            background: '#1A1A1A',
            color: '#F3F4F6',
            border: '1px solid #333333',
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AssessmentFlow />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
